export default "__VITE_ASSET__BGtrln80__"